import React from "react";
import { imgUrl } from "../../../../api/api";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import ImageIcon from "@mui/icons-material/Image";
import LinkIcon from "@mui/icons-material/Link";

const fmtDuration = (ms) => {
  if (!ms) return '0:00';
  const total = Math.floor(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
};

function PlaylistContentCardItem(props) {
  const { content, playID, deleteContent, addSchedule, updateTimeHandler } = props;

  const TypeIcon = content.type === 'video'
    ? <OndemandVideoIcon style={{ fontSize: 14, color: '#551FFF' }} />
    : content.type === 'image'
    ? <ImageIcon style={{ fontSize: 14, color: '#FF6A00' }} />
    : <LinkIcon style={{ fontSize: 14, color: '#00B7FE' }} />;

  return (
    <div className="pci-row">
      {/* 썸네일 */}
      <div className="pci-thumb">
        {content.type === 'image' && (
          <img src={`${imgUrl}/${content.url}`} alt={content.name} />
        )}
        {content.type === 'video' && (
          <div className="pci-thumb-video">
            <video src={`${imgUrl}/${content.url}`} />
            <OndemandVideoIcon style={{ position: 'absolute', color: 'white', fontSize: 18 }} />
          </div>
        )}
        {content.type === 'url' && (
          <div className="pci-thumb-url">
            <LinkIcon style={{ color: '#551FFF', fontSize: 22 }} />
          </div>
        )}
      </div>

      {/* 파일명 + 타입 */}
      <div className="pci-info">
        <span className="pci-name" title={content.name}>{content.name || content.url}</span>
        <span className="pci-type">{TypeIcon} {content.type}</span>
      </div>

      {/* 재생 시간 (클릭하면 수정) */}
      <button
        className="pci-duration"
        onClick={() => updateTimeHandler(playID, content._id, content.duration)}
        title="클릭하여 재생 시간 수정"
      >
        <AccessTimeIcon style={{ fontSize: 13 }} />
        {fmtDuration(content.duration)}
      </button>

      {/* 액션 버튼 */}
      <div className="pci-actions">
        <button
          className="pci-action-btn pci-action-btn--schedule"
          onClick={() => addSchedule(playID, content._id)}
          title="스케줄"
        >
          <ScheduleSendIcon style={{ fontSize: 16 }} />
        </button>
        <button
          className="pci-action-btn pci-action-btn--delete"
          onClick={() => deleteContent(playID, content._id)}
          title="삭제"
        >
          <DeleteOutlineIcon style={{ fontSize: 16 }} />
        </button>
      </div>
    </div>
  );
}

export default PlaylistContentCardItem;
